import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'fgbcl-shared-search-bar',
  templateUrl: './shared-search-bar.component.html',
  styleUrls: ['./shared-search-bar.component.scss']
})
export class SharedSearchBarComponent implements OnInit {
  @Output() searchTextEmitter = new EventEmitter<string>();
  searchText: string;
  constructor() { }

  ngOnInit(): void {
  }
  search() {
   this.searchTextEmitter.emit(this.searchText);
  }
}
